import $axios from "../api/accessor";
import { $api } from "../api/api";
import { getCookie } from "../utils/utils";

const token = getCookie("BscAdminToken");

export const VideosService = {
  async getAllVideos() {
    const response = await $axios
      .get($api("videos"))
      .catch((err) => err.response);
    return {
      data: response?.data ? response.data : [],
      status: response?.status,
    };
  },

  // ✅ FormData ilə ADD
  async addVideo(formData: FormData) {
    try {
      const { data, status } = await $axios.post($api("videos"), formData, {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "multipart/form-data",
        },
      });
      return { data, status };
    } catch (err: any) {
      const errorMessage = err.response?.data?.message;
      return { data: null, status: err.response?.status, errorMessage };
    }
  },

  // ✅ FormData ilə UPDATE
  async updateVideo(id: number | string, formData: FormData) {
    try {
      // Əgər backend PUT + multipart qəbul edirsə:
      const { data, status } = await $axios.patch(
        $api("videos_id", { id }),
        formData,
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "multipart/form-data",
          },
        }
      );

      return { data, status };
    } catch (err: any) {
      // Əgər backend PUT qəbul eləmirsə (çox backend belə olur),
      // bu alternativi aktiv et:
      // formData.append("_method", "PUT");
      // const { data, status } = await $axios.post($api("videos_id", { id }), formData, {
      //   headers: {
      //     Authorization: `Bearer ${token}`,
      //     "Content-Type": "multipart/form-data",
      //   },
      // });
      // return { data, status };

      const errorMessage = err.response?.data?.message;
      return { data: null, status: err.response?.status, errorMessage };
    }
  },

  async deleteVideo(id: string) {
    const response = await $axios
      .delete($api("videos_id", { id }), {
        headers: { Authorization: `Bearer ${token}` },
      })
      .catch((err) => err.response);

    return { data: response?.data, status: response?.status };
  },
};
